module.exports = __webpack_public_path__ + "static/5_section-bg-a398d05b31842885baeb5aec4aed0c5b.png";